import React from "react";
import './Card.css';
import { DownloadIcon } from "./icons/DownloadIcon";

type Props = {
  id: string;
  name: string;
  category: string;
	description: string;
	update: Date;
	url: string;
  renderDescription?: true;
}

export const Card: React.FC<Props> = ({ id, name, description, update, url, renderDescription }: Props) => {
	
  return (
    <span className="card" id={id}>
      <h3>{name}</h3>
			<p className="date">{new Date(update).toLocaleDateString().replace(/\//g, '-')}</p>
      {!renderDescription
        ? <p className="description">{description}</p>
        : <p className="description" dangerouslySetInnerHTML={{__html: description}} />
      }
      <a className="download-button" href={url}>
        <DownloadIcon width="1.375rem" height="1.375rem" color="white" />
        <span className="download-text"> 
          Download
        </span>
      </a>
    </span>
  );
};
